import FilterDialog from './Dialog'
import { useSelector } from 'react-redux'
import FilterButton from '../../../../filter/FilterButton'

const FilterButtonLearningContinuum = () => {
  const open = useSelector(state => state?.filter?.lc?.open || false)

  return (
    <>
      <FilterButton 
        module='lc'
        keysFilter={['lcElements']} 
      />
      
      { open &&
        <FilterDialog />
      }
    </>
  )
}
export default FilterButtonLearningContinuum